// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The data type of the waterDischarge entry
 */
export type DataType = 'Validated' | 'Provisional';

export const DataType = {
    Validated: 'Validated' as DataType,
    Provisional: 'Provisional' as DataType
};

